import { AutosuggestProps } from "@amzn/awsui-components-react-v3"

import { RequestPropertyIds } from "../data/BackendEntityConstants"
import { CoManagerEntry } from "../interfaces"
import { Employee, Property } from "../interfaces/RFXBackendModel"
import { createProperty } from "./RFXUtils"

export function convertCoManagerEntriesToProperty(coManagerEntries: CoManagerEntry[]): Property {
  const coManagerEntriesStr = JSON.stringify(coManagerEntries);
  return createProperty(RequestPropertyIds.CoManagers, coManagerEntriesStr, 'String')
}

export function convertCoManagerEntryOptionToCoManagerEntry(value: string, tags: string[]): CoManagerEntry {
  const firstName = value.substring(0, value.indexOf(','))
  const lastName = value.substring(value.indexOf(',') + 1, value.indexOf('(')).trim()
  const alias = value.substring(value.indexOf('(') + 1, value.indexOf(')'))
  return {
    firstName,
    lastName,
    alias,
    title: tags[0],
    department: tags[1],
  }
}

export function convertEmployeeToCoManagerEntryOption(employee: Employee): AutosuggestProps.Option {
  return {
    iconUrl: `https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${employee.alias}`,
    value: `${employee.firstName}, ${employee.lastName} (${employee.alias})`,
    tags: [employee.title ? employee.title : '', employee.department ? employee.department : ''],
  }
}

/**
 * Convert employee to CoManagerEntry Option. If the employee is already in the
 * currentCoManagerEntries then that Option is disabled
 */
export function convertEmployeesToCoManagerEntryOptions(
  employeeList: Employee[],
  currentCoManagerEntries: CoManagerEntry[],
): AutosuggestProps.Option[] {
  const coManagerEntriesMap = new Map(
    currentCoManagerEntries.map(coManagerEntry => [coManagerEntry.alias, coManagerEntry])
  );
  const retVal = Array<AutosuggestProps.Option>();
  employeeList.forEach((employee) => {
    const coManagerEntryOption = convertEmployeeToCoManagerEntryOption(employee)
    if (coManagerEntriesMap.has(employee.alias)) {
      retVal.push({
        ...coManagerEntryOption,
        disabled: true,
      })
    } else {
      retVal.push(coManagerEntryOption)
    }
  })
  return retVal;
}
